const iconPath = '/line-assets/img/valueIcons/';
export const valueToIconMap = {
	Gold: iconPath + 'Gold.png',
	Silver: iconPath + 'Silver.png',
	TritecAdouble: iconPath + 'TritecAdouble.svg',
	TritecAquad: iconPath + 'TritecAquad.svg',
	TritecAsingle: iconPath + 'TritecAsingle.svg',
	TritecAtriple: iconPath + 'TritecAtriple.svg',
	TritecSdouble: iconPath + 'TritecSdouble.svg',
	TritecSquad: iconPath + 'TritecSquad.svg',
	TritecSsingle: iconPath + 'TritecSsingle.svg',
	TritecStriple: iconPath + 'TritecStriple.svg',
};
